import styled from "styled-components";

import { StyledTable } from "@styles/components/Table.styled";
import { rem } from "@styles/Utilities.styled";


export const StyledGeneralTabTable = styled(StyledTable)`
  thead {
    th:last-child {
      text-align: right;
    }
  }

  tbody {
    tr {
      height: ${rem(67)};

      .last-updated {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 1rem;

        @media screen and (pointer: coarse) {
          display: none;
        }
      }

      @media screen and (pointer: fine) {
        &:hover {
          .table-controls {
            opacity: 1;
            z-index: 1;
            pointer-events: all;
          }

          .last-updated {
            opacity: 0;
            pointer-events: none;
            z-index: -1;
          }
        }

        .table-controls {
          opacity: 0;
          z-index: -1;
          pointer-events: none;

          &:focus-within {
            opacity: 1;
            z-index: 1;
            pointer-events: all;

            & + .last-updated {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  th,
  td {
    &:nth-child(3) {
      text-align: left !important;
    }

    &:last-child {
      position: relative;
      width: max-content;
    }
  }
`;
